import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import KnowledgeModal from './KnowledgeModal'
import { hasKb } from '../data/knowledgeBase'

interface KnowledgeCtx {
  /** Otevře popup s vysvětlením. `ids` = pořadí pro listování Předchozí/Další. */
  open: (startId: string, ids?: string[]) => void
}

const Ctx = createContext<KnowledgeCtx>({ open: () => {} })

export function useKnowledge() {
  return useContext(Ctx)
}

export default function KnowledgeProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<{ startId: string; ids: string[] } | null>(null)

  const open = useCallback((startId: string, ids?: string[]) => {
    if (!hasKb(startId)) return
    const list = (ids && ids.length ? ids : [startId]).filter(hasKb)
    setState({ startId, ids: list })
  }, [])

  return (
    <Ctx.Provider value={{ open }}>
      {children}
      {state && (
        <KnowledgeModal ids={state.ids} startId={state.startId} onClose={() => setState(null)} />
      )}
    </Ctx.Provider>
  )
}
